export default __webpack_public_path__ + "static/media/wild-swim.64d9b359.svg";